var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.leftAlign)?_c('div',[_c('PageMainLinkToPageInner',{attrs:{"link":_vm.link,"buttonText":_vm.buttonText}})],1):_c('center',[_c('PageMainLinkToPageInner',{attrs:{"link":_vm.link,"buttonText":_vm.buttonText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }